import React from 'react';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { PageHero } from '../components/PageHero';
import { Phone, MapPin, Facebook } from 'lucide-react';
import { PHONE, PHONE_TEL, GOOGLE_MAPS_URL, FACEBOOK_URL } from '../constants/business';
export function FAQ() {
  useDocumentMeta('Kjergaard Sports FAQ | Store Visits, Firearms, Classes & Location', 'Frequently asked questions about visiting Kjergaard Sports, our firearm selection, ammunition, classes, and store policies.');
  const faqs = [{
    q: 'Where is Kjergaard Sports located?',
    a: 'We are located at 1951 200th Avenue, Lake Benton, Minnesota 56149. We are a rural destination store, and many customers drive long distances to visit us.'
  }, {
    q: 'Do you sell products directly through this website?',
    a: 'No. Kjergaard Sports does not conduct sales directly through this website. This site is for business information only.'
  }, {
    q: 'Can I call about current in-store availability?',
    a: `Yes, please call us at ${PHONE} to check current availability for specific firearms, ammunition, or gear.`
  }, {
    q: 'Do you carry new and used firearms?',
    a: 'Yes, we have approximately 5,000 new and used firearms on hand, catering to hunters, sport shooters, and collectors.'
  }, {
    q: 'Do you carry ammunition?',
    a: 'Yes, we stock a large selection of ammunition for hunting, target shooting, and personal defense. Call for current caliber availability.'
  }, {
    q: 'Do you carry optics?',
    a: 'Yes, we carry scopes, binoculars, spotting scopes, and rangefinders.'
  }, {
    q: 'Do you carry reloading supplies?',
    a: 'Yes, we stock bullets, powder, primers, presses, and reloading tools.'
  }, {
    q: 'Do you have safes and accessories?',
    a: 'Yes, we carry gun safes, cases, holsters, cleaning supplies, and other shooting accessories.'
  }, {
    q: 'Do you offer Minnesota Permit to Carry classes?',
    a: 'Yes, we periodically host classes. Please call the store or check our Facebook page for upcoming dates.'
  }, {
    q: 'Where can I find current hours and event updates?',
    a: 'Please call the store or check our Facebook page for current hours, class dates, and store updates.'
  }, {
    q: 'How do firearm sales and transfers work?',
    a: 'All firearm-related sales and transfers are handled in-store and in accordance with applicable federal, state, and local laws. Requirements vary. Please call the store and consult applicable laws.'
  }, {
    q: 'Can out-of-state customers visit?',
    a: 'Yes, out-of-state customers are welcome to visit and browse. However, firearm purchases and transfers are subject to federal and state laws. Please call the store with specific questions regarding out-of-state transactions.'
  }];
  return <div data-id="element-446">
      <PageHero title="Frequently Asked Questions" image="https://cdn.magicpatterns.com/uploads/6uBKPbVFcv4swNygT9aBpc/home-hero-store-interior.jpg" alt="Inside Kjergaard Sports sporting goods store" data-id="element-447" />

      <section className="py-20 bg-brand-offwhite bg-texture" data-id="element-448">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-449">
          <div className="space-y-6" data-id="element-450">
            {faqs.map((faq, index) => <div key={index} className="bg-brand-bone p-8 rounded-sm border border-brand-cream" data-id="element-451">
                <h3 className="text-xl font-serif text-brand-charcoal mb-3" data-id="element-452">
                  {faq.q}
                </h3>
                <p className="text-brand-charcoal/80 leading-relaxed" data-id="element-453">
                  {faq.a}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      <section className="py-20 bg-brand-hunter text-brand-offwhite" data-id="element-454">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-455">
          <h2 className="text-3xl md:text-4xl font-serif mb-6" data-id="element-456">
            Still Have Questions?
          </h2>
          <p className="text-lg text-brand-offwhite/80 mb-10 max-w-2xl mx-auto" data-id="element-457">
            If you didn't find the answer you were looking for, our team is
            ready to help. Reach out to us directly or visit the store.
          </p>

          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-458">
            <a href={PHONE_TEL} className="inline-flex items-center justify-center bg-brand-leather hover:bg-brand-wood text-brand-offwhite px-8 py-4 rounded-sm font-medium transition-colors" data-id="element-459">
              <Phone className="w-5 h-5 mr-2" data-id="element-460" />
              Call {PHONE}
            </a>
            <a href={GOOGLE_MAPS_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-brand-offwhite text-brand-hunter hover:bg-brand-bone px-8 py-4 rounded-sm font-medium transition-colors" data-id="element-461">
              <MapPin className="w-5 h-5 mr-2" data-id="element-462" />
              Get Directions
            </a>
            <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center border border-brand-offwhite/30 hover:border-brand-offwhite text-brand-offwhite px-8 py-4 rounded-sm font-medium transition-colors" data-id="element-463">
              <Facebook className="w-5 h-5 mr-2" data-id="element-464" />
              Facebook
            </a>
          </div>
        </div>
      </section>
    </div>;
}